import { createStore } from 'vuex'
import auth from './modules/auth'
import boxTypes from './modules/box-types'
import roles from './modules/roles'
import diagnoses from './modules/diagnoses'
import treatments from './modules/treatments'
import categories from './modules/categories'
import boxes from './modules/boxes'
import cities from './modules/cities'
import documents from './modules/documents'
import users from './modules/users'

export default createStore({
  modules: {
    auth,
    boxTypes,
    roles,
    diagnoses,
    treatments,
    categories,
    boxes,
    cities,
    documents,
    users,
  },
})
